<div class="ma-terms-conditions" [class.is-rtl]="isRtl$ | async">
    <div *ngIf="showTermsAll">
        <div class="checkbox-item mb-16" [formGroup]="form">
            <input
                [formControlName]="TermsAll"
                id="termsAll"
                [checked]="allTermsAndConditionsChecked$ | async"
                name="termsAll"
                type="checkbox"
                (change)="checkAllTerms($event)"
            />

            <label for="termsAll">
                <i class="icon">
                    <svg-icon2 category="common" src="check-mini"></svg-icon2>
                </i>
                <span class="text-l">{{ 'dev.general.privacyPolicy.terms_all' | translate }}</span>
            </label>
        </div>
    </div>
    <!-- Contenido de términos y condiciones -->
    <div *ngIf="arrLineTerms$ | async as arrLineTerms">
        <div *ngFor="let lineTerms of arrLineTerms; trackBy: trackByIndex; let i = index" class="mb-16">
            <div
                class="checkbox-item"
                *ngIf="{
                    hasError: form.controls['termsAndConditionsCheck_' + lineTerms.label].invalid
                } as data"
                [class.is-error]="form.touched && form.status === 'INVALID' && data.hasError"
                [formGroup]="form"
            >
                <!-- Checkbox -->
                <input
                    [formControlName]="'termsAndConditionsCheck_' + lineTerms.label"
                    id="{{ 'termsAndConditionsCheck_' + lineTerms.label + '_' + idRandom }}"
                    [name]="'termsAndConditionsCheck_' + lineTerms.label"
                    type="checkbox"
                    (change)="termsChange($event)"
                />

                <label for="{{ 'termsAndConditionsCheck_' + lineTerms.label + '_' + idRandom }}" [class.mb-32]="lineTerms.externalScrollContent">
                    <i class="icon">
                        <svg-icon2 category="common" src="check-mini"></svg-icon2>
                    </i>

                    <!-- Para mobile o para Desktop sin tooltip -->
                    <div class="ma-wrapper-terms" *ngIf="isMobile || (!isMobile && !lineTerms.tooltipMode)">
                        <div class="ma-wrapper-terms-inner">
                            <div class="ma-wrapper-terms-item">
                                <ng-container *ngFor="let textPart of lineTerms.messages">
                                    <!-- Líneas de texto con imagen como en el caso de Feel actual en legacy-->

                                    <span class="text-l" *ngIf="textPart.textImage">{{ textPart.textImage }}</span>
                                    <span *ngIf="!textPart?.clickText" class="text-l" [textContent]="textPart.text"></span>
                                    <span
                                        class="text-l link-line bold"
                                        *ngIf="textPart?.clickText"
                                        [textContent]="textPart.text"
                                        (click)="open($event, lineTerms, textPart)"
                                    ></span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <!-- Para Desktop en formato Tooltip -->
                    <div class="ma-wrapper-terms" *ngIf="!isMobile && lineTerms.tooltipMode">
                        <div class="ma-wrapper-terms-inner">
                            <ng-container *ngFor="let textPart of lineTerms.messages">
                                <span *ngIf="!textPart?.clickText" class="text-l" [textContent]="textPart.text"></span>
                                <span
                                    class="text-l link-line"
                                    *ngIf="textPart?.clickText"
                                    [textContent]="textPart.text"
                                    (click)="this[textPart?.clickText](lineTerms.layer)"
                                ></span>
                            </ng-container>

                            <!-- Popup -->
                            <div class="itx-tooltip-warning" *ngIf="!lineTerms.twoTerms">
                                <app-input-terms-conditions-term
                                    *ngIf="termsData"
                                    [data]="lineTerms"
                                    [termsTextNumber]="2"
                                    [termsData]="termsData"
                                ></app-input-terms-conditions-term>
                            </div>

                            <span class="text-l" *ngIf="lineTerms.messages.text3" [textContent]="lineTerms.messages.text3"></span>

                            <div class="itx-tooltip-warning">
                                <app-input-terms-conditions-term
                                    *ngIf="termsData"
                                    [data]="lineTerms"
                                    [termsTextNumber]="4"
                                    [termsData]="termsData"
                                ></app-input-terms-conditions-term>
                            </div>
                        </div>
                    </div>
                </label>

                <!-- Bloque custom para ng-messages -->

                <!-- Error custom  TOOLTIP -->
                <!-- <div
                            class="message-info floating mt-16"
                            *ngIf="
                            !lineTerms.showNgMessage &&
                            checkDirtyAndSubmittedAndRequired(lineTerms) &&
                            lineTerms.customErrorMessage
                            "
                        >
                            <span [textContent]="lineTerms.customErrorMessage"></span>
                        </div> -->

                <!-- Expansión para mostrar contenido en línea ( para turkia) -->

                <div _ngcontent-cry-c191="" class="row" *ngIf="lineTerms.externalScrollContent">
                    <div _ngcontent-cry-c191="" class="col-xs-12">
                        <div _ngcontent-cry-c191="" class="box3 border-1 mb-16">
                            <div _ngcontent-cry-c191="" class="box3-content">
                                <ng-container [ngSwitch]="lineTerms.externalScrollContentType">
                                    <mspot
                                        *ngSwitchCase="'mspot'"
                                        [name]="lineTerms.externalScrollContent"
                                        [templateData]="mspotTemplateData | async"
                                    ></mspot>
                                    <distance-sale-contract *ngSwitchCase="'distance-sale-contract'"></distance-sale-contract>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!--
                <div class="scrollable-content" *ngIf="lineTerms.externalScrollContent" itx-scrollbar>
                    <div class="content">
                        {{ lineTerms.externalScrollContent }}
                            <itx-marketing-spot
                                name="{{ lineTerms.externalScrollContent }}"
                                compile="lineTerms.extrernalScrollContentCompile"
                                model="{'termsConditionsCtrl':lineTerms.data}"
                            ></itx-marketing-spot>
                    </div>
                </div>
                -->
            </div>
        </div>
    </div>
</div>
